import { FOCO_VISIVEL } from 'utils/foco';

interface PilulaDoCicloProps {
  titulo: string;
  className?: string;
}

/**
 * Pílula "Ciclo {título}" do cabeçalho do Feed e das páginas "Ver todos". Alcançável por Tab como o resto do texto
 * do Feed (`.eslintrc.notes.md`: o padrão só muda de uma vez, em todas as telas).
 */
export default function PilulaDoCiclo({ titulo, className = '' }: PilulaDoCicloProps) {
  return (
    // SPEC_DEVIATION: fundo `brand-blue-dark` (design `brand-blue`, 4,44:1 com o texto amarelo).
    <span
      tabIndex={0}
      className={`rounded-full bg-brand-blue-dark px-4 py-2 font-display text-[12px] font-bold text-brand-yellow ${FOCO_VISIVEL} ${className}`}
    >
      Ciclo {titulo}
    </span>
  );
}
